import avatar from './assets/davatar.png'
import { db } from '../firebase'

const uuidv4 = require('uuid/v4')
const FIREBASE_REF_PROFILE = db.ref('Users');
const FIREBASE_REF_MESSAGES = db.ref('Messages');
// const FIREBASE_REF_UNREAD = db.ref('Unread');

export const giftedChatSendMessage = (text, uid, adminUid, adminName) => {
    var data = {
        _id: uuidv4(),
        createdAt: Date.now(),
        text: text,
        user: {
            _id: adminUid || 'YwoUFx6DwJduNAs13vywxiaaeJx1',
            name: adminName || 'Horas Admin'
        }
    }
    return data;
}

export const sendMessageFirebase = (message, uid, adminUid, adminName) => {
    // const datetime = {datetime: Date.now()}
      FIREBASE_REF_MESSAGES.child(uid).push().set(giftedChatSendMessage(message, uid, adminUid, adminName))
      FIREBASE_REF_PROFILE.child(uid).once('value').then( snapshot => {
          var pushToken = snapshot.val().pushToken
          fetch('https://exp.host/--/api/v2/push/send', {
                body: JSON.stringify({
                to: pushToken,
                title: "New Message",
                body: message
                }),
                headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin':'*'
                },
                method: 'POST',
                mode: 'no-cors'
            });
      })
  }

// const removeFromUnread = (uid) => {
//     FIREBASE_REF_UNREAD.child(uid).remove()
// }
export const loadProfilePromise = (uid) => {
    return FIREBASE_REF_PROFILE.child(uid).once('value').then((snapshot) => {
        return snapshot.val();
    });
}

export const loadMessages = (uid) => {
    return FIREBASE_REF_MESSAGES.child(uid).once('value').then((snapshot) => {
        if (snapshot.exists){
            return snapshot.val();
        }
    });
}

export const getAvatarTitle = (name) => {
    var title = "NO"
    if (name){
        var names = name.split(' ')
        if (names.length > 1){
            title = names[0][0] + names[names.length-1][0]
        } else if (names.length === 1) {
            title = names[0][0]
        }
    }
    return title
}

var epoch_to_local = (epoch) => {
    var d = new Date(epoch)
    var date = d.getDate() + ' ' + d.toLocaleDateString('en-us', {month: 'short'})
    var created_at = d.getHours() + ':' + d.getMinutes()
    if (d.getDay()===0){
    }
    return {date, created_at}
}

export const loadMessagesList = (uid) => {
    var return_object = []
    if (uid){
        var is_admin=true
        var uid_messages = loadMessages(uid)
        Promise.all([uid_messages]).then(snapshot => {
            var results = snapshot[0]
            for (var key in results) {
                var data = results[key]
                var {date, created_at} = epoch_to_local(data.createdAt)
                var body = data.text
                var message_uid = data.user._id
                if (message_uid === uid) {
                    is_admin = false
                }
                return_object.push({uid, avatar, body, date, created_at, is_admin})
            }
        })
    }
    return return_object
}

export const loadConversationList = () => {
    var conversation_list = []
    FIREBASE_REF_MESSAGES.orderByKey().on('value', (snapshot) => {
        if (snapshot.exists()){
            snapshot.forEach((child, i) => {
                if (child.exists()) {
                    var birth_details = {}
                    var personal_information = {}
                    var each_object = {}
                    var child_object = child.val()[Object.keys(child.val())[Object.keys(child.val()).length - 1]]
                    var uid = child.key
                    each_object.uid = uid
                    var profiles_promise = loadProfilePromise(uid)
                    Promise.all([profiles_promise]).then(results => {
                        var profiles = results[0]
                        if (profiles){
                            each_object.avatar_title = getAvatarTitle(profiles.name)
                            each_object.full_name = profiles.name
                            each_object.username = profiles.email
                            if (profiles.avatar){
                                personal_information.avatar = profiles.avatar
                                each_object.avatar = profiles.avatar
                            }
                            else {
                                personal_information.avatar = avatar
                                each_object.avatar = avatar
                            }
                            personal_information.full_name = profiles.name
                            personal_information.username = profiles.email
                            personal_information.gender = profiles.gender
                            birth_details.country = profiles.birthCountry
                            birth_details.city = profiles.birthCity
                            birth_details.date = profiles.birthDate
                            birth_details.time = profiles.birthTime
                        }
                    })
                    each_object.created_at = child_object.createdAt
                    each_object.last_message = child_object.text
                    
                    each_object.personal_information = personal_information
                    each_object.birth_details = birth_details
                    if (i === 0) {
                        each_object.active='true'
                    }
                    conversation_list.push(each_object)
                }
            })
        }
    })
    return conversation_list
}

export const loadProfile = (uid) => {
    if (uid) {
        var profile_object = {}
        var personal_information = {}
        var birth_details = {}
        var profiles_promise = loadProfilePromise(uid)
        Promise.all([profiles_promise]).then(results => {
            var profiles = results[0]
            if (profiles){
                personal_information.avatar = profiles.avatar
                personal_information.full_name = profiles.name
                personal_information.username = profiles.email
                personal_information.gender = profiles.gender
                birth_details.country = profiles.birthCountry
                birth_details.city = profiles.birthCity
                birth_details.date = profiles.birthDate
                birth_details.time = profiles.birthTime
            }
        })
        profile_object.personal_information = personal_information
        profile_object.birth_details = birth_details
        return profile_object   
    } else {
        return {}
    }
}



// WEBPACK FOOTER //
// ./src/store/Store.js